import React from "react";
import { useCurrentFrame, interpolate } from "remotion";
import { VIDEO_WIDTH, VIDEO_HEIGHT } from "../../types";

interface Props {
    title: string;
    subtitle?: string;
    dateLabel: string;
    watermarkImage?: string;
    boatPhoto?: string;
}

export const Intro: React.FC<Props> = ({
    title,
    subtitle,
    dateLabel,
    watermarkImage,
    boatPhoto,
}) => {
    const frame = useCurrentFrame();

    const opacity = interpolate(frame, [0, 15], [0, 1], {
        extrapolateRight: "clamp",
    });
    const translateY = interpolate(frame, [0, 15], [30, 0], {
        extrapolateRight: "clamp",
    });

    return (
        // Background always visible — only animate the text content
        <div
            style={{
                width: VIDEO_WIDTH,
                height: VIDEO_HEIGHT,
                background: "linear-gradient(180deg, #0a1628 0%, #1a3a5c 100%)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <div
                style={{
                    opacity,
                    transform: `translateY(${translateY}px)`,
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                {watermarkImage && (
                    <img
                        src={watermarkImage}
                        crossOrigin="anonymous"
                        style={{
                            maxHeight: 220,
                            maxWidth: 420,
                            width: "auto",
                            objectFit: "contain",
                            marginBottom: 80,
                        }}
                    />
                )}
                <div
                    style={{
                        color: "#ffffff",
                        fontSize: 96,
                        fontWeight: 700,
                        fontFamily: "system-ui, sans-serif",
                        lineHeight: 1.1,
                        padding: "0 80px",
                    }}
                >
                    {title}
                </div>
                {boatPhoto && (
                    <img
                        src={boatPhoto}
                        crossOrigin="anonymous"
                        style={{
                            width: 280,
                            height: 280,
                            objectFit: "cover",
                            borderRadius: 24,
                            marginTop: 40,
                            boxShadow: "0 20px 60px rgba(0, 0, 0, 0.4)",
                        }}
                    />
                )}
                {subtitle && (
                    <div
                        style={{
                            color: "#cbd5e1",
                            fontSize: 60,
                            fontFamily: "system-ui, sans-serif",
                            marginTop: 20,
                            fontWeight: 400,
                        }}
                    >
                        {subtitle}
                    </div>
                )}
                <div
                    style={{
                        color: "#94a3b8",
                        fontSize: 52,
                        fontFamily: "system-ui, sans-serif",
                        marginTop: 40,
                    }}
                >
                    {dateLabel}
                </div>
            </div>
        </div>
    );
};
